var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-ups-feature-wrap"},[_c('div',{staticClass:"modern-grid"},_vm._l((_vm.iconboxs),function(iconbox){return _c('div',{key:iconbox.id,staticClass:"ht-box-icon style-02 wow move-up"},[_c('router-link',{staticClass:"link-secret",attrs:{"to":"/"}},[_c('div',{staticClass:"icon-box-wrap"},[_c('div',{staticClass:"icon react",class:{
              linux: iconbox.linux,
              macos: iconbox.macos,
              window: iconbox.window,
              android: iconbox.android,
              web: iconbox.web,
            }},[_c('i',{class:iconbox.icon})]),_c('div',{staticClass:"content"},[_c('h6',{staticClass:"heading"},[_vm._v(_vm._s(iconbox.heading))])])])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }